import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useToken } from "../context/TokenContext";
import { useFal } from "../context/FalContext";
import YildizArkaplan from "../components/YildizArkaplan";

const GUNUN_MESAJLARI = [
  "Bugün sana gelen düşünceler tesadüf değil...",
  "Kapılar kapanırken pencereler açılıyor, gözlerini aç.",
  "İçindeki ses seni doğruya götürüyor, dinle onu.",
  "Beklenmedik bir haberle güzel bir gün seni bekliyor.",
  "Sabır tohumları bugün meyve vermeye başlıyor.",
  "Kalbinin işaret ettiği yön, aklının onayladığından daha doğru.",
  "Geçmişin gölgesi bugünün ışığını engelleyemez.",
  "Yıldızlar bugün senin için hizalanmış, fırsatı kaçırma.",
  "Bir dönem kapanıyor, yenisi için hazır ol.",
  "Sezgilerine güven — içindeki falcı yanılmaz.",
  "Bugün verdiğin kararlar yarının kapılarını açacak.",
  "Beklenmedik bir yüz, beklenmedik bir şans getirebilir.",
  "Zorlu yollar en güzel manzaralara çıkar.",
  "Bugün biri seni düşünüyor, sen de hissediyorsun.",
  "Değişim korkutucu görünür ama seni bekleyen en güzel şeydir.",
];

const HERO_KART = {
  id: "kahve",
  icon: "☕",
  baslik: "Kahve Falı",
  aciklama: "Fincanında saklı olanı gör — geçmiş, şimdi ve gelecek bir arada",
  navigate: "/falcilar?fal=kahve",
  gradient: "linear-gradient(145deg, #5a2d00 0%, #8B4500 50%, #C05C00 100%)",
  border: "rgba(255,160,60,0.55)",
  shadow: "rgba(192,92,0,0.5)",
};

const ALT_KARTLAR = [
  {
    id: "el",
    icon: "✋",
    baslik: "El Falı",
    aciklama: "Avucundaki çizgiler konuşsun",
    navigate: "/falcilar?fal=el",
    gradient: "linear-gradient(145deg, #0A3060, #1565C0)",
    border: "rgba(80,160,255,0.5)",
    shadow: "rgba(21,101,192,0.45)",
  },
  {
    id: "yuz",
    icon: "👤",
    baslik: "Yüz Falı",
    aciklama: "Yüzündeki sırları oku",
    navigate: "/falcilar?fal=yuz",
    gradient: "linear-gradient(145deg, #4A0080, #8B00CC)",
    border: "rgba(190,100,255,0.5)",
    shadow: "rgba(139,0,204,0.4)",
  },
  {
    id: "iliski",
    icon: "💑",
    baslik: "İlişki Falı",
    aciklama: "Aşkın yolunu aydınlat",
    navigate: "/falcilar?fal=iliski",
    gradient: "linear-gradient(145deg, #7B0030, #C0003A)",
    border: "rgba(255,80,120,0.5)",
    shadow: "rgba(192,0,58,0.4)",
  },
  {
    id: "tarot",
    icon: "🃏",
    baslik: "Tarot",
    aciklama: "Kartlar sana ne söylüyor?",
    navigate: "/tarot",
    gradient: "linear-gradient(145deg, #1A5200, #2E8B00)",
    border: "rgba(100,220,60,0.5)",
    shadow: "rgba(46,139,0,0.4)",
    rozet: "YENİ",
    rozetRenk: "#4ADE80",
    rozetBg: "rgba(74,222,128,0.2)",
    rozetBorder: "rgba(74,222,128,0.5)",
  },
  {
    id: "numeroloji",
    icon: "🔢",
    baslik: "Numeroloji",
    aciklama: "Sayıların gizemi",
    navigate: null,
    token: null,
    gradient: "linear-gradient(145deg, #1A1060, #2D1FA0)",
    border: "rgba(120,140,255,0.4)",
    shadow: "rgba(45,31,160,0.4)",
    opacity: 0.6,
    rozet: "YAKINDA",
    rozetRenk: "#A5B4FC",
    rozetBg: "rgba(165,180,252,0.15)",
    rozetBorder: "rgba(165,180,252,0.4)",
  },
  {
    id: "yildizname",
    icon: "⭐",
    baslik: "Yıldızname",
    aciklama: "Yıldızların sesi",
    navigate: "/yildizname",
    token: null,
    gradient: "linear-gradient(145deg, #1a1a3a, #2a2060)",
    border: "rgba(200,180,255,0.4)",
    shadow: "rgba(100,80,200,0.3)",
  },
];

export default function AnaSayfa() {
  const navigate = useNavigate();
  const { tokenBalance, user, gunlukBonus } = useToken();
  const [bonusBildirim, setBonusBildirim] = useState(null);
  const { hazirFallar } = useFal();
  const gunlukMesaj = GUNUN_MESAJLARI[new Date().getDate() % GUNUN_MESAJLARI.length];

  useEffect(() => {
    if (!user) return;
    const kontrolEt = async () => {
      const sonuc = await gunlukBonus();
      if (sonuc?.success) setBonusBildirim(sonuc);
    };
    kontrolEt();
  }, [user]);

  const falNavigate = (hedef) => {
    if (!hedef) return;
    if (!user) { navigate("/giris"); return; }
    navigate(hedef);
  };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)", position: "relative", overflow: "hidden", fontFamily: "'Trebuchet MS', Tahoma, sans-serif", maxWidth: 420, margin: "0 auto" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@700&display=swap');
        @keyframes kart-gir { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes balik-yilan { 0%, 100% { transform: rotate(-6deg) scale(1); } 50% { transform: rotate(6deg) scale(1.05); } }
        @keyframes nabiz { 0%, 100% { opacity: 0.6; transform: scale(1); } 50% { opacity: 1; transform: scale(1.08); } }
        @keyframes logo-parlak { 0%, 100% { filter: drop-shadow(0 0 8px rgba(168,85,247,0.5)); } 50% { filter: drop-shadow(0 0 20px rgba(168,85,247,0.9)); } }
        @keyframes hero-parlak { 0%, 100% { box-shadow: 0 8px 40px rgba(192,92,0,0.5); } 50% { box-shadow: 0 12px 60px rgba(255,140,0,0.7); } }
        @keyframes ruya-parlak { 0%, 100% { box-shadow: 0 8px 40px rgba(74,40,120,0.5); } 50% { box-shadow: 0 12px 60px rgba(120,60,200,0.7); } }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      <YildizArkaplan />

      {bonusBildirim && (
        <div
          onClick={() => setBonusBildirim(null)}
          style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0,0,0,0.7)", zIndex: 1000,
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: 24,
          }}
        >
          <div style={{
            background: "linear-gradient(135deg, #1a0a3e, #2d1b5e)",
            border: "1px solid rgba(167,139,250,0.5)",
            borderRadius: 24, padding: "32px 24px", textAlign: "center", maxWidth: 300,
          }}>
            <div style={{ fontSize: 52, marginBottom: 12 }}>
              {bonusBildirim.streak === 7 ? "🎉" : "🎁"}
            </div>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#fff", marginBottom: 8 }}>
              {bonusBildirim.streak === 7 ? "7. Gün Bonusu!" : "Günlük Bonus!"}
            </div>
            <div style={{ fontSize: 28, fontWeight: 800, color: "#F9CB42", marginBottom: 8 }}>
              +{bonusBildirim.bonus} 🪙
            </div>
            <div style={{ fontSize: 13, color: "rgba(255,255,255,0.6)", marginBottom: 16 }}>
              {bonusBildirim.streak > 0 && `${bonusBildirim.streak}. gün serisi`}
              {bonusBildirim.streak === 6 && " — Yarın 200 token kazanırsın!"}
            </div>
            <button
              onClick={() => setBonusBildirim(null)}
              style={{
                width: "100%", padding: "12px", borderRadius: 12,
                background: "linear-gradient(135deg, #7c3aed, #a855f7)",
                border: "none", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer",
              }}
            >
              Harika! 🔮
            </button>
          </div>
        </div>
      )}
      <div style={{ position: "absolute", top: -100, left: "50%", transform: "translateX(-50%)", width: 500, height: 500, borderRadius: "50%", background: "radial-gradient(circle, rgba(120,50,200,0.18) 0%, transparent 65%)", pointerEvents: "none" }} />

      <div style={{ position: "relative", zIndex: 1, paddingBottom: 90 }}>

        {/* Header */}
        <div style={{ padding: "24px 20px 10px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img
              src="/logo.png"
              alt="Remil"
              style={{ width: 60, height: 60, borderRadius: 14, objectFit: "contain", animation: "logo-parlak 3s ease-in-out infinite" }}
            />
            <div>
              <div style={{ fontSize: 22, fontWeight: 700, color: "#fff", letterSpacing: 0.5 }}>Remil</div>
              <div style={{ fontSize: 10, color: "rgba(167,139,250,0.6)", letterSpacing: 1.2 }}>Kaderine bak, geleceğini gör</div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {user && (
              <div
                onClick={() => navigate("/token-kazan")}
                style={{ background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 20, padding: "6px 14px", display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "#F9CB42", fontWeight: 700, cursor: "pointer" }}
              >
                <span>🪙</span><span>{tokenBalance}</span>
              </div>
            )}
            <div style={{ position: "relative", cursor: "pointer" }} onClick={() => navigate("/fallarim")}>
              <div style={{ width: 38, height: 38, borderRadius: "50%", background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>🔔</div>
              {hazirFallar.length > 0 && (
                <div style={{ position: "absolute", top: -2, right: -2, width: 18, height: 18, borderRadius: "50%", background: "#F472B6", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#fff", fontWeight: 800, border: "2px solid #0a0718" }}>
                  {hazirFallar.length}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Günün Mesajı */}
        <div style={{ margin: "12px 16px 16px", borderRadius: 18, background: "linear-gradient(135deg, #4c1d95dd 0%, #6d28d9cc 100%)", border: "1px solid rgba(167,139,250,0.45)", padding: "14px 16px", display: "flex", alignItems: "center", gap: 14 }}>
          <div style={{ fontSize: 26, animation: "balik-yilan 3s ease-in-out infinite", flexShrink: 0 }}>🔮</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 9, color: "rgba(167,139,250,0.8)", letterSpacing: 1.8, textTransform: "uppercase", marginBottom: 4 }}>GÜNÜN MESAJI</div>
            <div style={{ fontSize: 15, color: "rgba(255,255,255,0.92)", lineHeight: 1.4, fontWeight: 500 }}>{gunlukMesaj}</div>
          </div>
        </div>

        {/* Falına Bak Label */}
        <div style={{ padding: "4px 16px 12px", fontSize: 11, color: "rgba(167,139,250,0.6)", letterSpacing: 2, textTransform: "uppercase", fontWeight: 600 }}>
          ✦ Falına Bak
        </div>

        {/* HERO KART — Kahve Falı */}
        <div style={{ padding: "0 16px 12px" }}>
          <div
            onClick={() => falNavigate(HERO_KART.navigate)}
            style={{
              borderRadius: 22,
              background: HERO_KART.gradient,
              border: `1px solid ${HERO_KART.border}`,
              animation: "hero-parlak 3s ease-in-out infinite",
              padding: "24px 22px",
              cursor: "pointer",
              position: "relative",
              overflow: "hidden",
            }}
            onMouseDown={(e) => { e.currentTarget.style.transform = "scale(0.98)"; }}
            onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
            onTouchStart={(e) => { e.currentTarget.style.transform = "scale(0.98)"; }}
            onTouchEnd={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
          >
            {/* Parıltı - sağ üst */}
            <div style={{ position: "absolute", top: 14, right: 18, width: 28, height: 28, borderRadius: "50%", background: "rgba(255,255,255,0.55)", pointerEvents: "none" }} />
            <div style={{ position: "absolute", top: 8, right: 10, width: 14, height: 14, borderRadius: "50%", background: "rgba(255,255,255,0.35)", pointerEvents: "none" }} />

            <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
              <div style={{ fontSize: 64, lineHeight: 1, flexShrink: 0 }}>☕</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontFamily: "'Cinzel', serif", fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 6, letterSpacing: 0.5 }}>Kahve Falı</div>
                <div style={{ fontSize: 13, color: "rgba(255,255,255,0.75)", lineHeight: 1.5, marginBottom: 14 }}>{HERO_KART.aciklama}</div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ background: "rgba(0,0,0,0.3)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 20, padding: "8px 22px", fontSize: 14, color: "#fff", fontWeight: 700, letterSpacing: 0.3 }}>
                    Fala Bak
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* HERO KART — Rüya Tabiri */}
        <div style={{ padding: "0 16px 12px" }}>
          <div
            onClick={() => falNavigate("/ruya-tabiri")}
            style={{
              borderRadius: 22,
              background: "linear-gradient(145deg, #1a0a2e 0%, #2d1b4e 50%, #4a2878 100%)",
              border: "1px solid rgba(130,80,220,0.55)",
              animation: "ruya-parlak 3s ease-in-out infinite",
              padding: "24px 22px",
              cursor: "pointer",
              position: "relative",
              overflow: "hidden",
            }}
            onMouseDown={(e) => { e.currentTarget.style.transform = "scale(0.98)"; }}
            onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
            onTouchStart={(e) => { e.currentTarget.style.transform = "scale(0.98)"; }}
            onTouchEnd={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
          >
            <div style={{ position: "absolute", top: 14, right: 18, width: 28, height: 28, borderRadius: "50%", background: "rgba(255,255,255,0.25)", pointerEvents: "none" }} />
            <div style={{ position: "absolute", top: 8, right: 10, width: 14, height: 14, borderRadius: "50%", background: "rgba(255,255,255,0.15)", pointerEvents: "none" }} />

            <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
              <div style={{ flexShrink: 0 }}>
                <img src="/efsunhanim.png" alt="Efsun Hanım" style={{ width: 80, height: "auto", borderRadius: 0, objectFit: "contain", border: "none", background: "none" }} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 11, color: "rgba(167,139,250,0.85)", marginBottom: 2, letterSpacing: 0.5 }}>Efsun Hanım</div>
                <div style={{ fontFamily: "'Cinzel', serif", fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 6, letterSpacing: 0.5 }}>Rüya Tabiri</div>
                <div style={{ fontSize: 13, color: "rgba(255,255,255,0.75)", lineHeight: 1.5, marginBottom: 14 }}>Bilinçaltının gizli mesajlarını çözümle</div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ background: "rgba(0,0,0,0.3)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 20, padding: "8px 22px", fontSize: 14, color: "#fff", fontWeight: 700, letterSpacing: 0.3 }}>
                    Rüyamı Yorumlat
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* HERO KART — Remil */}
        <div style={{ padding: "0 16px 12px" }}>
          <div
            onClick={() => falNavigate("/remil")}
            style={{
              borderRadius: 22,
              background: "linear-gradient(145deg, #1a1000 0%, #3d2800 50%, #5a3a00 100%)",
              border: "1px solid rgba(201,168,76,0.45)",
              boxShadow: "0 8px 40px rgba(201,168,76,0.2)",
              padding: "24px 22px",
              cursor: "pointer",
              position: "relative",
              overflow: "hidden",
            }}
            onMouseDown={(e) => { e.currentTarget.style.transform = "scale(0.98)"; }}
            onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
            onTouchStart={(e) => { e.currentTarget.style.transform = "scale(0.98)"; }}
            onTouchEnd={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
          >
            <div style={{ position: "absolute", top: 10, left: 14, background: "rgba(201,168,76,0.2)", border: "1px solid rgba(201,168,76,0.5)", borderRadius: 10, padding: "2px 8px", fontSize: 9, color: "#C9A84C", fontWeight: 800, letterSpacing: 0.5 }}>YENİ</div>
            <div style={{ position: "absolute", top: 14, right: 18, width: 28, height: 28, borderRadius: "50%", background: "rgba(201,168,76,0.3)", pointerEvents: "none" }} />
            <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
              <div style={{ fontSize: 64, lineHeight: 1, flexShrink: 0 }}>◆</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 11, color: "rgba(201,168,76,0.7)", marginBottom: 2, letterSpacing: 1 }}>Kadim Kum Falı</div>
                <div style={{ fontFamily: "Georgia, serif", fontSize: 20, fontWeight: 700, color: "#C9A84C", marginBottom: 6 }}>Remil</div>
                <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", lineHeight: 1.5, marginBottom: 14 }}>Kumun sembolleri sana ne söylüyor?</div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ background: "rgba(0,0,0,0.3)", border: "1px solid rgba(201,168,76,0.3)", borderRadius: 20, padding: "8px 22px", fontSize: 14, color: "#C9A84C", fontWeight: 700 }}>
                    Fala Bak
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Alt Grid — 2 sütun, 3 satır */}
        <div style={{ padding: "0 16px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          {ALT_KARTLAR.map((kart, i) => (
            <div
              key={kart.id}
              onClick={() => !kart.opacity && falNavigate(kart.navigate)}
              style={{
                borderRadius: 18,
                background: kart.gradient,
                border: `1px solid ${kart.border}`,
                boxShadow: `0 4px 20px ${kart.shadow || "transparent"}`,
                padding: "16px 14px",
                textAlign: "center",
                cursor: kart.opacity ? "default" : "pointer",
                opacity: kart.opacity || 1,
                position: "relative",
                overflow: "hidden",
                animation: "kart-gir 0.6s ease backwards",
                animationDelay: `${i * 80}ms`,
              }}
              onMouseDown={(e) => { if (!kart.opacity) e.currentTarget.style.transform = "scale(0.96)"; }}
              onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
              onTouchStart={(e) => { if (!kart.opacity) e.currentTarget.style.transform = "scale(0.96)"; }}
              onTouchEnd={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
            >
              {/* Parıltı - sağ üst */}
              <div style={{ position: "absolute", top: 7, right: 7, width: 14, height: 14, borderRadius: "50%", background: "rgba(255,255,255,0.6)", pointerEvents: "none" }} />

              {/* Rozet */}
              {kart.rozet && (
                <div style={{
                  position: "absolute", top: 7, left: 7,
                  background: kart.rozetBg || "rgba(255,255,255,0.1)",
                  border: `1px solid ${kart.rozetBorder || "rgba(255,255,255,0.2)"}`,
                  borderRadius: 10, padding: "2px 7px", fontSize: 8,
                  color: kart.rozetRenk || "#fff", fontWeight: 800, letterSpacing: 0.5,
                }}>
                  {kart.rozet}
                </div>
              )}

              <div style={{ fontSize: 28, marginBottom: 7 }}>{kart.icon}</div>
              <div style={{ fontFamily: "'Cinzel', serif", fontSize: 12, fontWeight: 700, color: "#fff", marginBottom: 4 }}>{kart.baslik}</div>
              <div style={{ fontSize: 10, color: "rgba(255,255,255,0.6)", lineHeight: 1.35 }}>{kart.aciklama}</div>
            </div>
          ))}
        </div>

        {/* Keşfet Label */}
        <div style={{ padding: "24px 16px 10px", fontSize: 11, color: "rgba(167,139,250,0.6)", letterSpacing: 2, textTransform: "uppercase", fontWeight: 600 }}>
          ✦ Keşfet
        </div>

        {/* Keşfet Kartları */}
        <div style={{ padding: "0 16px", display: "flex", flexDirection: "column", gap: 10 }}>

          {/* Falda Çıkan Semboller */}
          <div
            onClick={() => navigate("/falda-semboller")}
            style={{ borderRadius: 16, background: "linear-gradient(135deg, #2a1a0a, #3d2510)", border: "1px solid rgba(192,120,40,0.4)", padding: "16px 18px", display: "flex", alignItems: "center", gap: 14, cursor: "pointer" }}
            onMouseDown={(e) => { e.currentTarget.style.transform = "scale(0.97)"; }}
            onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
            onTouchStart={(e) => { e.currentTarget.style.transform = "scale(0.97)"; }}
            onTouchEnd={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
          >
            <div style={{ width: 46, height: 46, borderRadius: "50%", background: "rgba(160,90,20,0.25)", border: "1px solid rgba(192,120,40,0.5)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>
              ☕
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#fff", marginBottom: 3 }}>Falda Çıkan Semboller</div>
              <div style={{ fontSize: 11, color: "rgba(255,200,130,0.7)" }}>Fincanında gördüğün sembollerin anlamları</div>
            </div>
            <div style={{ fontSize: 18, color: "rgba(255,255,255,0.3)" }}>›</div>
          </div>

          {/* Rüyada Çıkan Semboller */}
          <div
            onClick={() => navigate("/ruya-semboller")}
            style={{ borderRadius: 16, background: "linear-gradient(135deg, #1a0a2e, #2d1550)", border: "1px solid rgba(109,40,217,0.4)", padding: "16px 18px", display: "flex", alignItems: "center", gap: 14, cursor: "pointer" }}
            onMouseDown={(e) => { e.currentTarget.style.transform = "scale(0.97)"; }}
            onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
            onTouchStart={(e) => { e.currentTarget.style.transform = "scale(0.97)"; }}
            onTouchEnd={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
          >
            <div style={{ width: 46, height: 46, borderRadius: "50%", background: "rgba(100,40,200,0.2)", border: "1px solid rgba(109,40,217,0.5)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>
              🌙
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#fff", marginBottom: 3 }}>Rüyada Çıkan Semboller</div>
              <div style={{ fontSize: 11, color: "rgba(180,140,255,0.7)" }}>Rüyanda gördüğün sembollerin yorumları</div>
            </div>
            <div style={{ fontSize: 18, color: "rgba(255,255,255,0.3)" }}>›</div>
          </div>

          {/* Simya (Pasif) */}
          <div
            style={{ borderRadius: 16, background: "linear-gradient(135deg, #1a1500, #2a2000)", border: "1px solid rgba(180,140,0,0.25)", padding: "16px 18px", display: "flex", alignItems: "center", gap: 14, opacity: 0.6, cursor: "default", position: "relative" }}
          >
            <div style={{ width: 46, height: 46, borderRadius: "50%", background: "rgba(160,120,0,0.2)", border: "1px solid rgba(180,140,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>
              ⚗️
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#fff", marginBottom: 3 }}>Simya</div>
              <div style={{ fontSize: 11, color: "rgba(255,220,100,0.5)" }}>Madde ve ruhun dönüşümü</div>
            </div>
            <div style={{ background: "rgba(180,140,0,0.2)", border: "1px solid rgba(180,140,0,0.4)", borderRadius: 10, padding: "3px 10px", fontSize: 10, color: "#d4a017", fontWeight: 700 }}>Yakında</div>
          </div>

        </div>

      </div>
    </div>
  );
}
